import { useEffect, useState } from "react";
import { useLetterDetail } from "@/hooks/letter";
import { resolveLetterImages } from "@/utils/letter";

/** Read-only letter preview view model. */

/** Fetches a letter's detail and resolves its asset images for a read-only preview. */
export function useLetterPreview(patientId, letterId, workspaceId) {
  var _detail$data$letter, _detail$data, _detail$data$name, _detail$data2;
  var detail = useLetterDetail(patientId, letterId);
  var _useState = useState(""),
    html = _useState[0],
    setHtml = _useState[1];
  var _useState2 = useState(false),
    isResolving = _useState2[0],
    setIsResolving = _useState2[1];
  var raw = (_detail$data$letter = (_detail$data = detail.data) === null || _detail$data === void 0 ? void 0 : _detail$data.letter) !== null && _detail$data$letter !== void 0 ? _detail$data$letter : "";
  useEffect(function () {
    if (!raw) {
      setHtml("");
      return;
    }
    var active = true;
    setIsResolving(true);
    resolveLetterImages(raw, workspaceId).then(function (resolved) {
      return active && setHtml(resolved);
    })["catch"](function () {
      return active && setHtml(raw);
    })["finally"](function () {
      return active && setIsResolving(false);
    });
    return function () {
      active = false;
    };
  }, [raw, workspaceId]);
  return {
    html: html,
    name: (_detail$data$name = (_detail$data2 = detail.data) === null || _detail$data2 === void 0 ? void 0 : _detail$data2.name) !== null && _detail$data$name !== void 0 ? _detail$data$name : "",
    isLoading: detail.isLoading || isResolving
  };
}